<template>
    <div class="m-zoom-controls zoom-controls">
        <button
            type="button"
            class="zoom-controls__button"
            :aria-label="ariaLabelOnZoomIn"
            tabindex="-1"
            @click="onZoomIn"
        >
            <svg-icon
                original
                name="icons/plus"
                class="zoom-controls__icon"
            />
        </button>
        <button
            type="button"
            class="zoom-controls__button"
            :aria-label="ariaLabelOnZoomOut"
            tabindex="-1"
            @click="onZoomOut"
        >
            <svg-icon
                original
                name="icons/minus"
                class="zoom-controls__icon"
            />
        </button>
    </div>
</template>

<script>
import { SET_NORMALIZED_ZOOM } from '../../../shared/components/map-viewer/constants/map-commands';

export default {
    name: 'MZoomControls',
    props: {
        ariaLabelOnZoomIn: {
            type: String,
            default: 'On zoom in'
        },
        ariaLabelOnZoomOut: {
            type: String,
            default: 'On zoom out'
        }
    },
    methods: {
        onZoomIn() {
            this.$bus.$emit(SET_NORMALIZED_ZOOM, { mode: 'zoom' });
        },
        onZoomOut() {
            this.$bus.$emit(SET_NORMALIZED_ZOOM, { mode: 'out' });
        }
    }
}
</script>

<style lang="scss">
@import "m-zoom-controls";
</style>